// extracted by mini-css-extract-plugin
export default {"page":"jY-z","cartModal":"kY-z","checkout":"lY-z","placeholder":"mY-z","account":"nY-z"};